<template>
  <v-container>
    <v-card
      :loading="false"
    >
      <v-overlay
        :absolute="true"
        :value="isComponentLoading"
      >
        <v-progress-circular indeterminate size="24"></v-progress-circular>
      </v-overlay>
      <v-row class="pa-2">
        <v-col>
          <div v-if="stats" style="max-width: 100%; overflow-x: auto;">
            <table id="customers">
              <thead>
              <tr>
                <th>
                  {{ $t('table.headers.name') }}
                </th>
                <th>
                  {{ $t('table.headers.phone') }}
                </th>
                <th>
                  {{ $t('table.headers.qty') }}
                </th>
              </tr>
              </thead>
              <tbody>
              <template v-for="stat in stats">
                <tr :key="stat.key">
                  <td colspan="3" style="text-align: center; background-color: #330000; color: white">
                    <span class="font-weight-bold">{{ stat.key }}</span>
                  </td>
                </tr>
                <tr :key="stat.key" v-if="stat.value.length <= 0">
                  <td colspan="3" style="text-align: center;">
                    <span class="">{{ $t('stats.no_orders') }}</span>
                  </td>
                </tr>
                <template v-else>
                  <tr :key="stat.key + i" v-for="(row, i) in stat.value">
                    <td>{{ row.name }}</td>
                    <td class="text-center">{{ row.phone }}</td>
                    <td class="text-center">{{ row.count }}</td>
                  </tr>
                  <tr>
                    <td colspan="2">{{ $t('stats.total_orders_month') }}:</td>
                    <td class="text-center">{{ stat.sum }}</td>
                  </tr>
                </template>
              </template>
              </tbody>
            </table>
          </div>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
import updatePageContentMixin from '@/mixins/updatePageContentMixin';
import StatsOrdersSubscriptionByManagerProxy from '@/proxies/Stats/StatsOrdersSubscriptionByManagerProxy';
import i18n from '@/i18n';

export default {
  mixins: [updatePageContentMixin],
  data() {
    return {
      isComponentLoading: false,
      stats: [],
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.isComponentLoading = true;
      new StatsOrdersSubscriptionByManagerProxy()
        .all()
        .then((response) => {
          this.stats = response.data.data.stats.map(month => ({
            ...month,
            sum: month.value.reduce((sum, order) => sum + order.count, 0),
          }));
        })
        .catch(() => {
          this.$store.dispatch('page/displaySnackbar', {
            text: i18n.t('stats.error_stats'),
            color: 'red darken-3',
            timeout: 6000,
          });
        })
        .finally(() => {
          this.isComponentLoading = false;
          this.$store.dispatch('page/finishUpdateCurrentPageContent');
        });
    },
  },
};
</script>

<style>
#customers {
  font-family: "Trebuchet MS", Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
  font-size: 12px;
}

#customers td, #customers th {
  border: 1px solid #ddd;
  padding: 8px;
}

#customers tr:nth-child(even) {
  background-color: #f2f2f2;
}

#customers tr:hover {
  background-color: #ddd;
}

#customers th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
  background-color: #4CAF50;
  color: white;
}

#customers .bolder-row {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
  background-color: #af5149;
  color: white;
}
</style>
